import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=f3cb6d84&scoped=true"
import script from "./promo.vue?vue&type=script&lang=js"
export * from "./promo.vue?vue&type=script&lang=js"
import style0 from "./promo.vue?vue&type=style&index=0&id=f3cb6d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cb6d84",
  null
  
)

export default component.exports